$(function () {
  var brandB_sliderTop = new Swiper('.brand_b .slider_top', {
      a11y: false,
      loop:true,
      fadeEffect: { crossFade: true },
      effect: "fade",
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 300,
      navigation : {
        nextEl: '.slider_top-next-button-store',
        prevEl: '.slider_top-prev-button-store'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
  });
  $('.brand_a .slider_top').slick({
    autoplay:{
        delay: 3000
    },
    arrows:false,
    dots: true,
    autoplay: false,
    adaptiveHeight: true,
    fade: true,
    cssEase: 'ease',
    pauseOnHover: false,
    pauseOnFocus: false
  });

  $('.brand_c .slider_top').slick({
    autoplay:{
        delay: 3000
    },
    arrows:false,
    dots: true,
    autoplay: true,
    adaptiveHeight: true,
    swipeToScroll: true,
    fade: true,
    cssEase: 'ease',
    pauseOnHover: false,
    pauseOnFocus: false
  });
  $('.slider_top').on('touchstart', function () {
    $(this).slick('slickPlay');
  });
  $('.brand_a .slider_topics').slick({
    autoplay:false,
    arrows:true,
    slidesToShow: 3,
    dots: true,
    centerMode: true,
    adaptiveHeight: true,
    speed: 300,
    centerPadding: '10%',
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            centerPadding: '0%',
            speed: 3000
        }
    }]
  });
  $('.brand_a .slider_topics_2').slick({
    autoplay:false,
    arrows:true,
    slidesToShow: 4.4,
    dots: true,
    centerMode: true,
    adaptiveHeight: true,
    responsive: [{
      breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0%',
      }
    }
    ]
  });
  $('.brand_a .slider_topics_3').slick({
    autoplay:false,
    arrows:true,
    dots:true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [{
      breakpoint: 768,
        settings: {
            autoplay: false,
            arrows:true,
            infinite: true,
            dots:true,
            slidesToShow: 1,
            slidesToScroll: 1,
      }
    }
    ]
  });

  var C_tb_carousel = new Swiper('.C_tb_carousel', {
    a11y: false,
    slidesPerView: 1,
    loop: false,
    fadeEffect: { crossFade: true },
    effect: "fade",
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    speed: 300,
    pagination: {
        el: '.C_tb_carousel .swiper-pagination',
        clickable: true
      },
  });
  
  $('.brand_a .slider_news_2').slick({
      autoplay:false,
      arrows:true,
      slidesToShow: 2,
      dots: true,
      adaptiveHeight: true,
      responsive: [{
        breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: false,
            centerPadding: '0%',
        }
      }
      ]
  });

  $('.brand_b .slider_news_2').slick({
    autoplay:false,
    arrows:true,
    slidesToShow: 3,
    dots: false,
    adaptiveHeight: true,
    responsive: [{
      breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerMode: false,
          centerPadding: '0%',
      }
    }
    ]
  });

  $('.slider_news_b2').slick({
      autoplay:false,
      arrows:true,
      dots:false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 768,
          settings: {
              autoplay: false,
              arrows:true,
              infinite: true,
              dots:true,
              slidesToShow: 1,
              slidesToScroll: 1,
        }
      }
      ]
  });
  $('.brand_a .slider_label').slick({
      autoplay:false,
      arrows:true,
      slidesToShow: 3,
      dots: true,
      autoplay: false,
      prevArrow: false,
      nextArrow: false,
      responsive: [{
        breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            arrows:false,
            centerPadding: '0%',
        }
      }
      ]
  });
  
})
$(function() {
    $('ul.tab-group li').click(function (e) {
        $('ul.tab-group .is-active').removeClass('is-active');
        $(this).toggleClass('is-active');
        $('.panel-group .is-show').removeClass('is-show');
        $(`.panel-group .categoryBrands-${$(this).data('id')}`).toggleClass('is-show');
        e.stopPropagation();
    });
    $(".more_button_store_2, .more_button_brand_2").on("click", function() {
        $(this).toggleClass("on-click");
        $(".txt-hide_store").slideToggle(800);
    });
});


//--------topb------------//
$(function () {
    function sliderSetting(){
        var width = $(window).width();
        if(width <= 769){
            $('.brand_b .slider_topics').not('.slick-initialized').slick({
                autoplay: false,
                centerMode: false,
                arrows:true,
                infinite: true,
                dots:true,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerPadding: '0px',
            });
        } else {
            $('.brand_b .slider_topics .slide.slick-initialized').slick('unslick');
        }
    }
    sliderSetting();
    $(window).resize(sliderSetting());
})

$(function() {
    var elm = $('.swiper-container');
    var isloop = [];
    elm.each((index, element) => {
        isloop.push($(element).data('infinite-slide'));
        var dataId = $(element).data('id');
        var prevBtn = '.prev-button-' + dataId;
        var nextBtn = '.next-button-' + dataId;
        var swiper;
        var optionDefault = {
          slidesPerView: 2.2,
          centeredSlides: false,
          navigation: false,
          a11y: false,
          breakpoints: {
              769: {
                slidesPerView: 4,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn
                },
              }
          }
        }

      swiper = new Swiper('.' + dataId, optionDefault);
      $(window).on('resize', function () {
        swiper.update();
      });

    });
});

$(function() {
  var elm = $('.swiper-ranking-container');        
  elm.each((index, element) => {
      var swiper = new Swiper('.' + $(element).data('id'), {
          slidesPerView: "auto",
          slidesPerView: 2.1,
          preloadImages: true,
          centeredSlides: false,
          loop: true,
          navigation: false,
          a11y: false,
          breakpoints: {
              769: {
                slidesPerView: 5,
                navigation: {
                  nextEl: '.next-button-' + $(element).data('id'),
                  prevEl: '.prev-button-' + $(element).data('id')
                },
              },
            }
      });
  });
})

$(function(){
  function sliderSetting(){
      var width = $(window).width();
      if(width <= 769){
          $('.styling_block').not('.slick-initialized').slick({
              autoplay: false,
              centerMode: false,
              arrows:false,
              infinite: true,
              dots:false,
              slidesToShow: 2,
              slidesToScroll: 1,
              centerPadding: '0px',
          });
      } else {
          $('.styling_block .slide.slick-initialized').slick('unslick');
      }
  }
  sliderSetting();
  $(window).resize(sliderSetting());
});

$(function(){
  function sliderSetting(){
      var width = $(window).width();
      if(width <= 769){
          $('.brand_a .slider_news_3').not('.slick-initialized').slick({
              autoplay: false,
              centerMode: false,
              arrows:false,
              infinite: true,
              dots:true,
              slidesToShow: 2,
              slidesToScroll: 1,
              centerPadding: '0px',
          });
      } else {
          $('.brand_a .slider_news_3 .slide.slick-initialized').slick('unslick');
      }
  }
  sliderSetting();
  $(window).resize(sliderSetting());
});

$(function(){
  function sliderSetting(){
      var width = $(window).width();
      if(width <= 769){
          $('.brand_a .slider_blog').not('.slick-initialized').slick({
              autoplay: false,
              centerMode: false,
              arrows:false,
              infinite: true,
              dots:false,
              slidesToShow: 2,
              slidesToScroll: 1,
              centerPadding: '0px',
          });
      } else {
          $('.brand_a .slider_blog .slide.slick-initialized').slick('unslick');
      }
  }
  sliderSetting();
  $(window).resize(sliderSetting());
});

$(function(){
  function sliderSetting(){
      var width = $(window).width();
      if(width <= 769){
          $('.items_men').not('.slick-initialized').slick({
              autoplay: false,
              centerMode: false,
              arrows:false,
              infinite: false,
              dots:false,
              slidesToShow: 2.5,
              slidesToScroll: 1,
          });
      } else {
          $('.items_men .slide.slick-initialized').slick('unslick');
      }
  }
  sliderSetting();
  $(window).resize(sliderSetting());
});

$(document).ready(function() {
  
  $('.maison_block1 .swiper-wrapper').not('.slick-initialized').slick({
    autoplay: true,
    autoplaySpeed: 1000,
    speed: 500,
    fade: true,
    centerMode: false,
    arrows: true,
    infinite: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: '0px',
    cssEase: 'linear'
  });

    var width = $(window).width();
    if (width > 769) {
        $('.maison_block3 .slider-wrapper').not('.slick-initialized').slick({
            autoplay: false,
            arrows: true,
            infinite: true,
            dots: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            centerPadding: '0px',
            prevArrow: $('.prev-btn'),
            nextArrow: $('.next-btn')
        });
    }

  $('.maison_block2 .ss-center').slick({
    speed: 650,
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    centerMode: true,
    slidesToShow: 1,
    centerPadding: "25%",
    slidesToScroll: 1,
    variableWidth: true,
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    responsive: [{
      breakpoint: 768,
      settings: {
        centerPadding: '10%',
        slidesToShow: 1
      }
    }]
  });
});

$(document).on('click', '.maison_block2 .slick-slide', function () {
  var currentIndex = Number($(this).attr('data-slick-index'));
  var detectItem1 = $('.maison_block2 .slick-slide[data-slick-index="' + (currentIndex - 1) + '"]');
  var detectItem2 = $('.maison_block2 .slick-slide[data-slick-index="' + (currentIndex + 1) + '"]');

  if ($(detectItem1).hasClass('slick-active')) {
    $(".maison_block2 .slick-next").click();
  }

  if ($(detectItem2).hasClass('slick-active')) {
    $(".maison_block2 .slick-prev").click();
  }
});


var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
  }
  return false;
};

$('.brand_c .slider_top_arrows').slick({
  autoplay:{
      delay: 3000
  },
  arrows:true,
  autoplay: true,
  adaptiveHeight: true,
  swipeToScroll: true,
  fade: true,
  cssEase: 'ease',
  pauseOnHover: false,
  pauseOnFocus: false
});